import { ChevronLeft, ChevronRight } from 'lucide-react';

/** Bìa tờ lịch: đỏ son, tên tháng bên trái, năm bên phải, bộ chọn tháng nằm ngay trên bìa (một kiểu duy nhất cho mọi màn). */
/** `quarter` (nếu có) thay cho tháng: tiêu đề "Quý N"; `month` null và không có quý = cả năm. */
export default function LeafHeader({ month, quarter, year, onStep }: { month: number | null; quarter?: number | null; year: number; onStep: (delta: number) => void }) {
  const unit = quarter != null ? 'Quý' : month === null ? 'Năm' : 'Tháng';
  const title = quarter != null ? `Quý ${quarter}` : month === null ? 'Cả năm' : `Tháng ${month}`;
  return (
    <div className="relative flex items-center justify-between rounded-t-lg bg-leaf px-3 py-3 text-white sm:px-5">
      <div className="flex items-center gap-1">
        <button onClick={() => onStep(-1)} aria-label={`${unit} trước`} className="flex h-9 w-9 items-center justify-center rounded-md hover:bg-white/15 focus-visible:outline-white"><ChevronLeft size={20} /></button>
        <h2 className="font-slab min-w-[7.5rem] text-center text-xl font-bold sm:text-2xl">{title}</h2>
        <button onClick={() => onStep(1)} aria-label={`${unit} sau`} className="flex h-9 w-9 items-center justify-center rounded-md hover:bg-white/15 focus-visible:outline-white"><ChevronRight size={20} /></button>
      </div>
      <span className="font-slab num text-xl font-bold sm:text-2xl" aria-label={`Năm ${year}`}>{year}</span>
      <span aria-hidden className="absolute left-1/2 top-2 hidden h-3 w-3 -translate-x-1/2 rounded-full bg-background/90 ring-2 ring-black/10 sm:block" />
    </div>
  );
}
